module.exports = __webpack_public_path__ + "static/media/calendar.97ab15ca.svg";